<h2 id="page-title">Top Up Balance</h2>
<app-breadcrumb></app-breadcrumb>

<div class="container">
  <div *ngIf="!showInstructions" class="card">
    <div class="card-header">
      <h2>Select Top Up Method</h2>
    </div>

    <app-block-loading [show]="isLoading"></app-block-loading>

    <div class="card-content" *ngIf="!isLoading">
      <!-- Payment Method Selection -->
      <div class="payment-methods" *ngIf="!showInstructions">
        <h3 class="sub-title">Virtual Account</h3>
        <div *ngFor="let bank of paymentMethods" class="payment-method">
          <div class="payment-method-content">
            <p-radioButton
              [value]="bank"
              (ngModelChange)="onBankChange($event)"
              [(ngModel)]="selectedBank"
              name="bank"
            ></p-radioButton>
            <div class="bank-logo">
              <ng-container *ngIf="!isExternalLogoUrl(bank.logo)">
                <app-svg-loader [url]="getSvgLogoName(bank.logo)"></app-svg-loader>
              </ng-container>
              <ng-container *ngIf="isExternalLogoUrl(bank.logo)">
                <div class="bank-logo-skeleton" *ngIf="isLogoLoading(bank.logo || '')"></div>
                <img
                  [src]="getExternalLogoUrl(bank.logo)"
                  alt="Bank Logo"
                  class="bank-logo-img"
                  (load)="onLogoLoad(bank.logo || '')"
                  (error)="onLogoError(bank.logo || '')"
                  [style.display]="isLogoLoading(bank.logo || '') ? 'none' : 'block'"
                />
              </ng-container>
            </div>
            <div class="bank-info">
              <h3>{{ bank.name }}</h3>
            </div>
          </div>
        </div>
        <div class="button-container">
          <button
            gtmTrackClick
            [gtmEvent]="GTMEventType.SELECT_PAYMENT_METHOD_CHOSEN"
            [gtmCategory]="GTMEventCategory.BUTTON"
            pButton
            label="Next"
            [disabled]="!selectedBank"
            (click)="viewTopUpInstructions()"
            class="pg-button"
          ></button>
        </div>
      </div>

      <!-- Top Up Instructions -->
    </div>
  </div>
  <div class="top-up-instructions" *ngIf="showInstructions && topUpInstruction">
    <div class="container-group">
      <h3>Complete Your Top Up</h3>
      <div class="virtual-account-info">
        <div class="bank-info">
          <div class="bank-details">
            <div class="row">
              <div style="display: flex; flex-direction: column; justify-content: center">
                <h3>{{ selectedBank?.name }}</h3>
              </div>

              <div class="bank-logo">
                <ng-container *ngIf="!isExternalLogoUrl(selectedBank?.logo)">
                  <app-svg-loader [url]="getSvgLogoName(selectedBank?.logo)"></app-svg-loader>
                </ng-container>
                <ng-container *ngIf="isExternalLogoUrl(selectedBank?.logo)">
                  <div
                    class="bank-logo-skeleton"
                    *ngIf="isLogoLoading(selectedBank?.logo || '')"
                  ></div>
                  <img
                    [src]="getExternalLogoUrl(selectedBank?.logo)"
                    alt="Bank Logo"
                    class="bank-logo-img"
                    (load)="onLogoLoad(selectedBank?.logo || '')"
                    (error)="onLogoError(selectedBank?.logo || '')"
                    [style.display]="isLogoLoading(selectedBank?.logo || '') ? 'none' : 'block'"
                  />
                </ng-container>
              </div>
            </div>
            <hr class="divider" />
            <div class="account-number">
              <span class="label">Virtual Account Number</span>
              <div class="number-copy">
                <span class="number">{{ topUpInstruction.virtualAccountNumber }}</span>
                <button (click)="copyVirtualAccount()" class="copy-button">
                  <i style="rotate: 180deg" class="pi pi-clone"></i>
                  <div>Copy</div>
                </button>
              </div>
            </div>

            <div class="recipient">
              <span class="label">Recipient Name</span>
              <span class="name">{{ topUpInstruction.recipientName }}</span>
            </div>
          </div>
        </div>
        <div *ngIf="selectedBank?.acquirer == 'cimb'" class="warning-bar">
          <div style="margin-top: 2px">
            <app-svg-loader url="caution.svg"></app-svg-loader>
          </div>
          <span class="warning-text"
            >Top up CIMB Virtual Account only accepts transfers from CIMB.</span
          >
        </div>
        <div class="button-container">
          <button class="pg-button" label="Back" (click)="onBack()">Change Top Up Method</button>
        </div>
      </div>
    </div>

    <div class="instruction-steps">
      <h3>How to Top Up</h3>
      <p-accordion>
        <p-accordion-panel
          *ngFor="let instruction of topUpInstruction.instructions"
          [value]="instruction.title"
        >
          <p-accordion-header>
            {{ instruction.title }}
          </p-accordion-header>
          <p-accordion-content>
            <ol class="steps">
              <li *ngFor="let step of instruction.steps">{{ step }}</li>
            </ol>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </div>
  </div>
</div>
